import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Home::HouseMakerIndex::Component の Stimulus コントローラ。
// landIeul: HouseMakerIndex の「次の10社を表示する」で invisible の企業を 10 件ずつ visible へ移す。
// (SP のみボタン表示。PC は overflow スクロール枠に全件表示されるためボタンは CSS で非表示)
class SiteHomeHouseMakerIndexController extends Controller {
  static targets = ["visibleList", "invisibleList", "button"];

  declare readonly visibleListTarget: HTMLUListElement;
  declare readonly invisibleListTarget: HTMLUListElement;
  declare readonly hasButtonTarget: boolean;
  declare readonly buttonTarget: HTMLButtonElement;

  static NEXT_VISIBLE = 10;

  showNext(): void {
    const items = Array.from(this.invisibleListTarget.children).slice(
      0,
      SiteHomeHouseMakerIndexController.NEXT_VISIBLE,
    );
    items.forEach((el) => this.visibleListTarget.appendChild(el));
    // 残りが無くなったらボタンを取り除く (React: isInvisibleHouseMakers.length > 0 && ...)
    if (this.invisibleListTarget.children.length === 0 && this.hasButtonTarget) {
      this.buttonTarget.remove();
    }
  }
}

application.register(
  "site--home--house-maker-index",
  SiteHomeHouseMakerIndexController,
);
